var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiro = function SvgMiro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 400 400"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FD3",
    d: "M3 100.754C3 46.26 47.244 2 101.754 2h197.492C353.756 2 398 46.244 398 100.754v197.492c0 54.51-44.244 98.754-98.754 98.754H101.754C47.244 397 3 352.756 3 298.246z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1C1E",
    fillRule: "evenodd",
    d: "M265.573 77.35H229.74l29.889 52.5-65.723-52.5h-35.834l32.862 64.118-68.696-64.119H86.404l35.834 81.682-35.834 163.346h35.834l68.696-174.981-32.862 174.981h35.834l65.723-186.684-29.889 186.684h35.833l65.724-204.145-65.724-40.799z",
    clipRule: "evenodd"
  })));
};
export default SvgMiro;